import gql from "graphql-tag";

export const GENERATE_API_CREDENTIAL = gql`
  mutation generateApiCredential($data: GenerateApiCredentialInput) {
    generateApiCredential(data: $data) {
      id
      label
      allowedIps
      enabled
      usageCount
      ownedBy {
        id
        name
      }
      apiKey
    }
  }
`;

export const ROTATE_API_CREDENTIAL_SECRET = gql`
  mutation rotateApiCredentialSecret($where: ApiCredentialWhereInput) {
    rotateApiCredentialSecret(where: $where) {
      id
      label
      apiKey
    }
  }
`;

export const UPDATE_API_CREDENTIAL = gql`
  mutation updateApiCredential(
    $where: ApiCredentialWhereInput
    $data: ApiCredentialDataInput
  ) {
    updateApiCredential(where: $where, data: $data) {
      id
      label
      allowedIps
      enabled
    }
  }
`;

export const DELETE_API_CREDENTIAL = gql`
  mutation deleteApiCredential($where: ApiCredentialWhereInput) {
    deleteApiCredential(where: $where) {
      id
      label
    }
  }
`;

const apiCredentials = {
  GENERATE_API_CREDENTIAL,
  ROTATE_API_CREDENTIAL_SECRET,
  UPDATE_API_CREDENTIAL,
  DELETE_API_CREDENTIAL,
};

export default apiCredentials;
